var _a, _b;
import { __assign, __spreadArray } from "tslib";
import { reduxKey } from './constants';
import get from 'lodash/get';
import { setCurrentFolderId, unsetCurrentFolderId, setCurrentTierId, unsetCurrentTierId, changeCurrentMediaSource, replaceSelect, toggleAppendSelect, deselect, deselectAll, deselectMulti, setSearchInput, setSearchQuery, unsetSearchQuery, unsetSearchInput, initMediaPopup, setCurrentSubfolderId, unsetCurrentSubfolderId, showNewFolderPopup, hideNewFolderPopup, } from './actions';
import { getDeviationEntityId, getDeviationEntityIds, } from '../redux/normalizr/schemas/deviation';
var defaultState = {
    mode: null,
    currentFolderId: null,
    currentSubfolderId: null,
    currentTierId: null,
    currentMediaSource: null,
    searchInput: '',
    searchQuery: null,
    selectedDeviationEntityIds: [],
    selectionLimit: null,
    allowGifs: true,
    allowPremium: false,
    allowMature: true,
    allowUploads: true,
    allowMultipleUploads: true,
    isShowingNewGallectionPopup: false,
    onlyNewPaidFolders: false,
};
var actionHandlers = (_a = {},
    _a[initMediaPopup.toString()] = function (state, action) { return (__assign(__assign({}, state), { mode: action.payload.mode, currentFolderId: get(action.payload, 'gallectionFolder.folderId'), currentTierId: get(action.payload, 'tier.deviationId'), currentMediaSource: action.payload.mediaSource, selectionLimit: action.payload.selectionLimit, allowedDeviationTypes: action.payload.allowedDeviationTypes, allowGifs: action.payload.allowGifs, allowPremium: action.payload.allowPremium, allowMature: action.payload.allowMature, allowUploads: action.payload.allowUploads, allowMultipleUploads: action.payload.allowMultipleUploads, ignoreDeviationIds: action.payload.ignoreDeviationIds, minDeviationWidth: action.payload.minDeviationWidth, minDeviationHeight: action.payload.minDeviationHeight, mediaSourceTypes: action.payload.mediaSourceTypes, withMediaSourceSelector: action.payload.withMediaSourceSelector, isShowingNewGallectionPopup: action.payload.withNewGallectionPopupOpen, onlyNewPaidFolders: action.payload.onlyNewPaidFolders })); },
    _a[showNewFolderPopup.toString()] = function (state, action) { return (__assign(__assign({}, state), { isShowingNewGallectionPopup: true })); },
    _a[hideNewFolderPopup.toString()] = function (state, action) { return (__assign(__assign({}, state), { isShowingNewGallectionPopup: false })); },
    _a[setCurrentFolderId.toString()] = function (state, action) { return (__assign(__assign({}, state), { currentFolderId: action.payload })); },
    _a[unsetCurrentFolderId.toString()] = function (state) { return (__assign(__assign({}, state), { currentFolderId: null })); },
    _a[setCurrentSubfolderId.toString()] = function (state, action) { return (__assign(__assign({}, state), { currentSubfolderId: action.payload })); },
    _a[unsetCurrentSubfolderId.toString()] = function (state, action) { return (__assign(__assign({}, state), { currentSubfolderId: null })); },
    _a[setCurrentTierId.toString()] = function (state, action) { return (__assign(__assign({}, state), { currentTierId: action.payload })); },
    _a[unsetCurrentTierId.toString()] = function (state, action) { return (__assign(__assign({}, state), { currentTierId: null })); },
    _a[changeCurrentMediaSource.toString()] = function (state, action) { return (__assign(__assign({}, state), { currentMediaSource: action.payload })); },
    _a[setSearchInput.toString()] = function (state, action) { return (__assign(__assign({}, state), { searchInput: action.payload })); },
    _a[unsetSearchInput.toString()] = function (state, action) { return (__assign(__assign({}, state), { searchInput: '' })); },
    _a[setSearchQuery.toString()] = function (state, action) { return (__assign(__assign({}, state), { searchQuery: action.payload })); },
    _a[unsetSearchQuery.toString()] = function (state, action) { return (__assign(__assign({}, state), { searchQuery: null })); },
    _a[replaceSelect.toString()] = function (state, action) { return (__assign(__assign({}, state), { selectedDeviationEntityIds: [getDeviationEntityId(action.payload)] })); },
    _a[toggleAppendSelect.toString()] = function (state, action) {
        var selectedDeviationEntityIds = state.selectedDeviationEntityIds;
        var id = getDeviationEntityId(action.payload);
        var isSelected = selectedDeviationEntityIds.includes(id);
        var updatedSelectedDeviationEntityIds;
        if (isSelected) {
            updatedSelectedDeviationEntityIds = selectedDeviationEntityIds.filter(function (entityId) { return entityId !== id; });
        }
        else {
            updatedSelectedDeviationEntityIds = __spreadArray(__spreadArray([], selectedDeviationEntityIds), [id]);
        }
        return __assign(__assign({}, state), { selectedDeviationEntityIds: updatedSelectedDeviationEntityIds });
    },
    _a[deselect.toString()] = function (state, action) {
        var id = getDeviationEntityId(action.payload);
        return __assign(__assign({}, state), { selectedDeviationEntityIds: state.selectedDeviationEntityIds.filter(function (entityId) { return entityId !== id; }) });
    },
    _a[deselectMulti.toString()] = function (state, action) {
        var ids = getDeviationEntityIds(action.payload);
        return __assign(__assign({}, state), { selectedDeviationEntityIds: state.selectedDeviationEntityIds.filter(function (entityId) { return !ids.includes(entityId); }) });
    },
    _a[deselectAll.toString()] = function (state) { return (__assign(__assign({}, state), { selectedDeviationEntityIds: [] })); },
    _a);
var reducers = (_b = {},
    _b[reduxKey] = function (state, action) {
        if (state === void 0) { state = defaultState; }
        if (!actionHandlers[action.type]) {
            return state;
        }
        return actionHandlers[action.type](state, action) || state;
    },
    _b);
export default reducers;
//# sourceMappingURL=reducers.js.map